import sum from "lodash/sum";
import uniq from "lodash/uniq";
import uniqBy from "lodash/uniqBy";
import { createSlice } from "@reduxjs/toolkit";
// utils
import { collection, doc, getDoc, getDocs, query, where, onSnapshot } from "firebase/firestore";
import { DB } from "src/auth/FirebaseContext";
import {
  COURSE_CATEGORY_COLLECTION,
  COURSE_CLASS_COLLECTION,
  REGIONS_COLLECTION,
} from "src/constants/collectionsIds";
import uuidv4 from "src/utils/uuidv4";
const moment = require("moment");
// ----------------------------------------------------------------------
const events = {};

const initialState = {
  isLoading: false,
  error: null,
  courseCategories: [],
  regions: [],
  courses: [],
  selectedCourseCategory: false,
  openMap: false,
  coupons: [
    {
      id: 1,
      name: "Gutschein 200 CHF",
      amount: 200,
      avatar: "/assets/images/coupon1.png",
      quantity: 0,
    },
    {
      id: 2,
      name: "Gutschein 150 CHF",
      amount: 150,
      avatar: "/assets/images/coupon2.png",
      quantity: 0,
    },
    {
      id: 3,
      name: "Gutschein 100 CHF",
      amount: 100,
      avatar: "/assets/images/coupon3.png",
      quantity: 0,
    },
    {
      id: 4,
      name: "Gutschein 50 CHF",
      amount: 50,
      avatar: "/assets/images/coupon4.png",
      quantity: 0,
    },
    {
      id: 5,
      name: "Gutschein 25 CHF",
      amount: 25,
      avatar: "/assets/images/coupon5.png",
    },
  ],
  couponCart: [],
  checkout: {
    activeStep: 0,
    activeStepHome: 0,

    cart: [],
    subtotal: 0,
    total: 0,
    discount: 0,
    shipping: 0,
    billing: null,
    totalItems: 0,
    //courseCategory: "drivingLessons",
    courseCategory: null,
    region: null,
    selectedCourses: [],
    courseConfig: {},
  },
};

const slice = createSlice({
  name: "course",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    handleOpenMap(state) {
      state.openMap = true;
    },
    handleCloseMap(state) {
      state.openMap = false;
    },
    handleToogleMap(state) {
      state.openMap = !state.openMap;
    },
    handleToogleSelectedCourseCategory(state, action) {
      state.selectedCourseCategory = action.payload;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      //state.selectedCourseCategory = false;
      state.error = action.payload;
    },
    //add to coupon cart
    addToCouponCart(state, action) {
      state.couponCart = action.payload;
    },

    // GET COURSES
    getCourseCategoriesSuccess(state, action) {
      state.isLoading = false;
      state.courseCategories = action.payload;
      const updateCart = state.courseCategories.find(
        (course) => course.id === state.checkout.courseCategory?.id,
      );
      state.checkout.courseCategory = updateCart || null;
    },
    getCourseRegionsSuccess(state, action) {
      state.isLoading = false;
      state.regions = action.payload;
      const updateCart = state.regions.find((course) => course.id === state.checkout.region?.id);
      state.checkout.region = updateCart || null;
    },

    // GET COURSES
    getCoursesSuccess(state, action) {
      state.isLoading = false;
      state.courses = action.payload;
    },

    selectCourses(state, action) {
      if (!state.checkout.selectedCourses) state.checkout.selectedCourses = [];
      const { courseId, index } = action.payload;
      const course = state.courses.find((course) => course.id === courseId);
      let requireChange = true;
      for (let i = 0; i < index; i++) {
        if (!state.checkout.selectedCourses[i] && i < index) {
          requireChange = false;
          break;
        }
      }
      if (requireChange) {
        state.checkout.selectedCourses[index] = { ...course };
        state.checkout.selectedCourses = state.checkout.selectedCourses.slice(0, index + 1);
      }
    },

    // CHECKOUT
    getCart(state, action) {
      const cart = action.payload;

      const totalItems = sum(cart.map((course) => course.quantity));
      const subtotal = sum(cart.map((course) => course.price * course.quantity));
      state.checkout.cart = cart;
      state.checkout.discount = state.checkout.discount || 0;
      state.checkout.shipping = state.checkout.shipping || 0;
      state.checkout.billing = state.checkout.billing || null;
      state.checkout.subtotal = subtotal;
      state.checkout.total = subtotal - state.checkout.discount;
      state.checkout.totalItems = totalItems;
    },

    addToCart(state, action) {
      const newCourse = action.payload;
      const isEmptyCart = !state.checkout.cart.length;

      if (isEmptyCart) {
        state.checkout.cart = [...state.checkout.cart, newCourse];
      } else {
        state.checkout.cart = state.checkout.cart.map((course) => {
          const isExisted = course.id === newCourse.id;

          if (isExisted) {
            return {
              ...course,
              colors: uniq([...course.colors, ...newCourse.colors]),
              quantity: course.quantity + 1,
            };
          }

          return course;
        });
      }
      state.checkout.cart = uniqBy([...state.checkout.cart, newCourse], "id");
      state.checkout.totalItems = sum(state.checkout.cart.map((course) => course.quantity));
    },

    deleteCart(state, action) {
      const updateCart = state.checkout.cart.filter((course) => course.id !== action.payload);

      state.checkout.cart = updateCart;
    },
    selectCategory(state, action) {
      const updateCart = state.courseCategories.find((course) => course.id === action.payload);
      state.checkout.courseCategory = updateCart || null;
      state.checkout.region = null;
      state.checkout.selectedCourses = [];
    },
    selectRegion(state, action) {
      const updateCart = state.regions.find((course) => course.id === action.payload);
      state.checkout.region = updateCart || null;
      state.checkout.selectedCourses = [];
    },
    setRegion(state, action) {
      state.checkout.region = action.payload || null;
      state.checkout.selectedCourses = [];
    },
    updateCourseConfig(state, action) {
      state.checkout.courseConfig = action.payload || {};
    },

    resetCart(state) {
      state.checkout = {
        activeStep: 0,
        cart: [],
        subtotal: 0,
        total: 0,
        discount: 0,
        shipping: 0,
        billing: null,
        totalItems: 0,

        courseCategory: null,
        region: null,
        selectedCourses: [],
        courseConfig: {},
      };
    },

    backStep(state) {
      state.checkout.activeStep -= 1;
    },

    nextStep(state) {
      state.checkout.activeStep += 1;
    },

    gotoStep(state, action) {
      const step = action.payload;
      state.checkout.activeStep = step;
    },

    increaseQuantity(state, action) {
      const courseId = action.payload;

      const updateCart = state.checkout.cart.map((course) => {
        if (course.id === courseId) {
          return {
            ...course,
            quantity: course.quantity + 1,
          };
        }
        return course;
      });

      state.checkout.cart = updateCart;
    },

    decreaseQuantity(state, action) {
      const courseId = action.payload;
      const updateCart = state.checkout.cart.map((course) => {
        if (course.id === courseId) {
          return {
            ...course,
            quantity: course.quantity - 1,
          };
        }
        return course;
      });

      state.checkout.cart = updateCart;
    },

    createBilling(state, action) {
      state.checkout.billing = action.payload;
    },

    applyDiscount(state, action) {
      const discount = action.payload;
      state.checkout.discount = discount;
      state.checkout.total = state.checkout.subtotal - discount;
    },

    applyShipping(state, action) {
      const shipping = action.payload;
      state.checkout.shipping = shipping;
      state.checkout.total = state.checkout.subtotal - state.checkout.discount + shipping;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  selectCategory,
  selectRegion,
  updateCourseConfig,
  selectCourses,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity,
  handleToogleMap,
  handleOpenMap,
  handleCloseMap,
  handleToogleSelectedCourseCategory,
  addToCouponCart,
} = slice.actions;

// ----------------------------------------------------------------------

export const getCourseCategories = () => {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const ref = collection(DB, COURSE_CATEGORY_COLLECTION);
      const response = await getDocs(ref);
      dispatch(
        slice.actions.getCourseCategoriesSuccess(
          response.docs
            .map((doc) => ({ ...doc.data(), id: doc.id }))
            .sort((a, b) => {
              return Number(a.order || 0) - Number(b.order || 0);
            }),
        ),
      );
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
};

// ----------------------------------------------------------------------
let refRegion = null;
export const getCourseRegions = () => {
  return async (dispatch) => {
    if (refRegion) return;
    dispatch(slice.actions.startLoading());
    try {
      const ref = collection(DB, REGIONS_COLLECTION);
      refRegion = onSnapshot(ref, (snap) => {
        dispatch(
          slice.actions.getCourseRegionsSuccess(
            snap.docs.map((doc) => ({ ...doc.data(), id: doc.id })),
          ),
        );
      });
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
};
export const addListener = (type, func) => {
  if (!type) return () => {};
  if (!events[type]) events[type] = [];
  const uid = uuidv4();
  const event = {
    uid,
    func,
  };
  const remove = () => {
    if (!events[type]) return;
    const index = events[type].findIndex((event) => event.uid === uid);
    if (index < 0) return;
    events[type].splice(index);
  };
  events[type].push(event);
  return remove;
};
export const executeEvents = (type, data) => {
  if (!events[type]) return;
  events[type].forEach((item) => {
    item.func?.(data);
  });
};
// export const getCourseRegions = () => {
//   return async (dispatch) => {
//     dispatch(slice.actions.startLoading());
//     try {
//       const ref = collection(DB, REGIONS_COLLECTION);
//       const response = await getDocs(ref);
//       dispatch(
//         slice.actions.getCourseRegionsSuccess(
//           response.docs.map((doc) => ({ ...doc.data(), id: doc.id })),
//         ),
//       );
//     } catch (error) {
//       console.log(error);
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// };
export const getCourseRegionById = (regionId) => {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading(regionId));
    try {
      const ref = doc(DB, REGIONS_COLLECTION);
      const response = await getDoc(ref);
      dispatch(slice.actions.setRegion({ ...response?.data(), id: doc.id }));
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
};

// ----------------------------------------------------------------------

export const getCourseByRegionAndName = () => {
  return async (dispatch, state) => {
    const { courseCategory, region } = state().course?.checkout;
    if (!courseCategory || !region) return;
    dispatch(slice.actions.startLoading());
    try {
      const ref = collection(DB, COURSE_CLASS_COLLECTION);
      const queryByCategory = query(
        ref,
        where("courseType", "==", courseCategory?.id),
        where("regionId", "==", region?.id),
        where("startDateTime", ">=", moment().format("YYYY-MM-DD")),
      );
      const response = await getDocs(queryByCategory);
      dispatch(
        slice.actions.getCoursesSuccess(
          response.docs.map((doc) => ({ ...doc.data(), id: doc.id })),
        ),
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
};

export const getIconName = (type) => {
  const icons = {
    motorcycle: "fa:motorcycle",
    firstAid: "fa:medkit",
    VKU: "fa:trello",
    drivingLessons: "material-symbols:directions-car-rounded",
  };
  return icons[type];
};

export const drivingCategories = [
  { value: "1", label: "Auto - switched" },
  { value: "2", label: "Auto - automat " },
  { value: "3", label: "Pendant" },
  { value: "4", label: "Motorcycle" },
];

export const drivingAvailableList = [
  { value: "1", label: "Morning(08:00-12:00 )" },
  { value: "2", label: "Afternoon (12:00-17:00)" },
  { value: "3", label: "Evening(17:00-21:00)" },
];

export const drivingDaysList = [
  { value: "1", label: "Monday" },
  { value: "2", label: "Tuesday" },
  { value: "3", label: "Wednesday" },
  { value: "4", label: "Thursday" },
  { value: "5", label: "Friday" },
  { value: "6", label: "Saturday" },
  { value: "7", label: "Sunday" },
];
